//import Libraries
import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

//import Components
import Layout from '../../hoc/Layout/Layout'

import MyInfo from './MyInfo';

// import Cart from '../Store/Cart/Cart'
import * as mypageActions from './actions/mypageActions'

//import Style classes


const myPage = (props) => {

    const {user} = props;
    if(!user.login) {
        return (
            <Redirect to='/' />
        )
    }


    return (
        <Layout isStore={false} relative={true}>
            <MyInfo 
                universal={props.universal}
                user={props.user}
            />
        </Layout>
    )
}

const mapStateToProps = (state) => {
    return {
        universal : state.universal,
        user : state.user
    }
}

export default connect(mapStateToProps, null)(myPage);


// WEBPACK FOOTER //
// ./src/pages/MyPage/MyPage.js